module.exports = __webpack_public_path__ + "img/06.6bfdb045.png";